import bookingService from '@/http/services/booking'
import store from '../../../store'
export default {
  getBooking ({ commit }, id) {
    return bookingService.getBooking(store.state.apiUrl, id).then((booking) => {
      commit('setBooking', booking.data)
    })
  },
  getBookingRepeatServiceId ({ commit }, id) {
    return bookingService.getBookingRepeatServiceId(store.state.apiUrl, id).then((booking) => {
      commit('setBookingRepeatServiceId', booking.data)
    })
  },
  createSupportTicket ({commit}, data) {
    return bookingService.createSupportTicket(store.state.apiUrl, data).then((response) => {
      return response.data
    })
  },
  getBookingChangelog ({ commit }, id) {
    return bookingService.getBookingChangelog(store.state.apiUrl, id).then((booking) => {
      commit('setBookingChangelog', booking.data)
    })
  },
  resetWaitingTime ({ commit }, data) {
    return bookingService.resetWaitingTime(store.state.apiUrl, data).then((booking) => {
      return booking
    })
  },
  fixWaitingTimes ({ commit }, data) {
    return bookingService.fixWaitingTimes(store.state.apiUrl, data).then((booking) => {
      return booking
    })
  }
}
